import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookmarkButton"] */ "/vercel/path0/languex-app/src/app/blog/_components/BookmarkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryPills"] */ "/vercel/path0/languex-app/src/app/blog/_components/CategoryPills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterForm"] */ "/vercel/path0/languex-app/src/app/blog/_components/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/vercel/path0/languex-app/src/app/blog/_components/SearchBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/app/blog/_styles/blog.css");
